import usePrivateAxios from '@/common/api/usePrivateAxios'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { MaintenanceForwardingsDirectiveEntryKlass } from '@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type'

type UseMaintenanceWorkflowForwardingsDirectiveEntryKlasses = (
  workflowId: string | undefined,
) => UseQueryResult<MaintenanceForwardingsDirectiveEntryKlass[], unknown>

export const useMaintenanceWorkflowForwardingsDirectiveEntryKlasses: UseMaintenanceWorkflowForwardingsDirectiveEntryKlasses =
  (workflowId) => {
    const privateAxios = usePrivateAxios()

    return useQuery<
      { data: { data: MaintenanceForwardingsDirectiveEntryKlass[] } },
      unknown,
      MaintenanceForwardingsDirectiveEntryKlass[]
    >({
      enabled: !!workflowId,
      queryKey: ['maintenanceWorkflowForwardingsDirectiveEntryKlasses', workflowId],
      queryFn: () => privateAxios.get(`/maintenance/workflows/${workflowId}/forwardings_directive_entry_klasses`),
      select: (data) => data?.data?.data,
    })
  }
